export enum FiltersTypes {
  Contains = 'contains',
  Select = 'select',
  DateRange = 'date-range',
  NumberRange = 'number-range',
  RangeSlider = 'range-slider',
}

export type SelectFilter = {
  label: string;
  filter_type: FiltersTypes.Select;
  values: { id: number; name: string }[] | null;
};

export type ContainsFilter = {
  label: string;
  filter_type: FiltersTypes.Contains;
  values: null;
};

export type DateRangeFilter = {
  label: string;
  filter_type: FiltersTypes.DateRange;
  values: null;
  range: [string | null, string | null];
};

export type NumberRangeFilter = {
  label: string;
  filter_type: FiltersTypes.NumberRange;
  values: null;
  range: [number | null, number | null] | null;
};

export type RangeSliderFilter = {
  label: string;
  filter_type: FiltersTypes.RangeSlider;
  values: null;
  range: [number | null, number | null];
};

export type Filter =
  | SelectFilter
  | ContainsFilter
  | DateRangeFilter
  | NumberRangeFilter
  | RangeSliderFilter;

export type Filters = Record<string, Filter>;

export type OrdersFiltersResponse = Filters;
